<div class="relative min-h-screen flex flex-col">
    <app-navbar></app-navbar>

    <div class="flex-grow">
        <!-- Top Banner Section Start -->
        <div class="mb-10 banner-container">
            <div class="grid grid-cols-12">
                <div class="col-span-12">
                    <div class="w-full h-[450px] banner-wrapper">
                        <img src="/assets/images/banners/profile-banner.png" alt=""
                            class="object-cover w-full h-full">
                            <div class="flex items-center h-full banner-container-inner">
                                <div class="container mx-auto">
                                    <div class="p-[30px] text-center mt-[5em]">
                                        <h1 class="my-0 mb-2 text-[2em] sm:text-5xl md:text-[2.5em] text-white">
                                            <span class="font-bold mr-2">My Profile</span>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Top Banner Section End -->

        <!-- Profile Icon Section Start -->
        <div class="container mx-auto profile-sec text-right relative mb-4 px-5 sm:px-20">
            <div
                class="profile-img w-[120px] h-[120px] lg:w-[150px] lg:h-[150px] rounded-full md:absolute top-[-140px] right-[100px] transform -translate-y-1/2">
                <div class="w-full h-full rounded-full flex items-center justify-center custom-bg">
                    <mat-icon matListItemIcon
                        class="w-auto h-auto text-[4em] lg:text-[7em] text-white user-icon">account_circle</mat-icon>
                </div>
            </div>
        </div>
        <!-- Profile Icon Section End -->

        <!-- Profile Content Section Start -->
        <div class="container mx-auto mt-5 profile-form">
            <div class="md:text-center border-b-2 border-slate-200 dark:border-darkmode-400 sm:text-left">
                <div class="px-5 py-0 sm:px-20 sm:py-0">
                    <div class="text-3xl font-semibold text-start text-primary">Profile Details</div>
                </div>
                <div class="flex flex-col px-5 pt-10 pb-10 lg:flex-row sm:px-20 sm:pb-20 justify-between">
                    <div class="text-left">
                        <div class="mt-2 text-lg font-bold text-[#4c61ac]"> Name: <span
                                class="text-black">{{user_details?.data.name}}</span> </div>
                        <div class="mt-1">Phone: {{user_details?.data.phone}}</div>
                        <div class="mt-1">Email: {{user_details?.data.email}}</div>
                        <div class="mt-1"></div>
                    </div>
                    <div class="mt-4 text-left">
                        <button mat-flat-button color="primary" class="md:ml-5 update-btn" (click)="openDialog()">Update
                            Profile
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Profile Content Section End -->

        <!-- Booking Display Section Start -->
        <div class="booking-list-wrapper mb-10 pt-10">
            <div class="container mx-auto" *ngIf="latestBookings">
                <div class="px-5 py-0 sm:px-20 sm:py-0">
                    <div class="text-3xl font-semibold text-primary">My Latest Bookings</div>
                </div>
                <div class="md:custom-margin flex flex-wrap pt-5">
                    <div class="w-[450px] h-[450px] mx-auto my-5 pb-[3.5em] booking-list-card relative"
                        *ngFor="let bookingDatas of latestBookings">
                        <div class="image-wrapper">
                            <img src="/assets/images/card-bg.png" alt="">
                        </div>
                        <div class="flex items-center p-[0.5em] justify-center bg-[#f0f2f8] rounded-b-3xl">
                            <div class="w-[35px] h-[35px] mr-5">
                                <img src="/assets/images/main-icon.png" alt="" class="w-[100%] h-[100%] object-contain">
                            </div>
                            <h2 class="text-base">Booking Details</h2>
                        </div>
                        <h2 class="text-[#677db9] text-sm text-center mt-5 font-normal">Booking No :
                            <span class="text-[#6eabc6]">{{bookingDatas.booking_no}}</span>
                        </h2>
                        <h2 class="text-[#677db9] text-sm text-center mt-2 mb-5 font-normal">Patient Name :
                            <span class="text-[#6eabc6]">{{bookingDatas.patient[0]?.name}}</span>
                        </h2>
                        <div class="flex justify-between px-3">
                            <div class="icon-line-container">
                                <div>
                                    <div class="text-xs font-normal text-[#6eabc6]">
                                        <span class="icon-container">
                                            <img src="/assets/images/booking-icon.png" alt="">
                                        </span>
                                        <span>Booked On</span>
                                    </div>
                                    <p class="text-[0.75em] font-bold ml-[2.3em]">{{bookingDatas.created_at |
                                        date:'dd-MMMM-yyyy'}}</p>
                                </div>
                                <div>
                                    <div class="text-xs font-normal text-[#6eabc6]">
                                        <span class="icon-container">
                                            <img src="/assets/images/doctor-icon.png" alt="">
                                        </span>
                                        <span>Doctor</span>
                                    </div>
                                    <p class="text-[0.75em] font-bold ml-[2.3em]">{{bookingDatas.slot.entity}}</p>
                                </div>
                                <div>
                                    <div class="text-xs font-normal text-[#6eabc6]">
                                        <span class="icon-container">
                                            <img src="/assets/images/slot-icon.png" alt="">
                                        </span>
                                        <span>Slot On</span>
                                    </div>
                                    <p class="text-[0.75em] font-bold mb-0 ml-[2.3em]">
                                        {{bookingDatas.slot.start_time |
                                        date:'dd-MMMM-yyyy'}}</p>
                                </div>
                                <div class="vertical-line"></div>
                            </div>
                            <div class="icon-second-line-container">
                                <div>
                                    <div class="text-xs font-normal text-[#6eabc6]">
                                        <span class="icon-container">
                                            <img src="/assets/images/email-icon.png" alt="">
                                        </span>
                                        <span>Email</span>
                                    </div>
                                    <p class="text-[0.75em] font-bold ml-[2.3em]">{{bookingDatas.email}}</p>
                                </div>
                                <div>
                                    <div class="text-xs font-normal text-[#6eabc6]">
                                        <span class="icon-container">
                                            <img src="/assets/images/phone-icon.png" alt="">
                                        </span>
                                        <span>Phone</span>
                                    </div>
                                    <p class="text-[0.75em] font-bold ml-[2.3em]">{{bookingDatas.phone}}</p>
                                </div>
                                <div class="second-vertical-line"></div>
                            </div>
                        </div>
                        <div class="button-wrapper mt-[3.5em]"
                            *ngIf="!bookingDatas.booking_completely_rescheduled && !bookingDatas.is_cancelled">
                            <button mat-flat-button color="primary" class="gradient-btn"
                                (click)="applicantBookingDetails(bookingDatas.booking_no)">
                                <span class="text-white">View Details</span>
                            </button>
                        </div>
                        <p *ngIf="bookingDatas.booking_completely_rescheduled"
                            class=" mt-[3.5em] mb-5 ml-auto mr-[1em] text-xs group  text-center w-[100px] text-white py-[0.5em] px-[0.5em] bg-red-700">
                            Rescheduled
                        </p>
                        <p *ngIf="bookingDatas.is_cancelled"
                            class=" mt-[3.5em] mb-5 ml-auto mr-[1em] text-xs group  text-center w-[100px] text-white py-[0.5em] px-[0.5em] bg-red-700">
                            Cancelled
                        </p>
                    </div>
                    <div class="container mx-auto p-10 custom-border flex justify-center items-center"
                        *ngIf="latestBookings.length === 0">
                        <div class="custom-margin flex justify-center">
                            <p class="text-[#667ac3] text-center">
                                "Sorry, but we couldn't find any bookings at the moment. Please consider broadening your search
                                criteria or checking back later. If you have any specific questions or need assistance, feel free to
                                contact our support team. We're here to help!"
                            </p>
                        </div>
                    </div>
                </div>
                <div class="text-center" *ngIf="showBtn">
                    <button mat-flat-button color="primary" class="mx-auto view-all-btn" (click)="allBookings()">
                        <span class="text-white">View All Bookings</span>
                    </button>
                </div>

            </div>
        </div>
        <!-- Booking Display Section End -->
    </div>

    <!-- Mat Spinner Start  -->
    <ngx-spinner bdColor="rgba(256, 256, 256, 0.8)" size="default" color="#6eabc6" type="ball-spin-fade"
        [fullScreen]="true">
        <p style="color: black"> Fetching Details... </p>
    </ngx-spinner>
    <!-- Mat Spinner End  -->

    <!-- App Footer Start  -->
    <app-message></app-message>
    <app-footer></app-footer>
    <!-- App Footer end  -->
</div>